import { AspectRatio, Box, Flex } from "@chakra-ui/react";
import { Info } from "lucide-react";
import { FC, ReactNode } from "react";

type Props = {
  children: React.ReactNode;
  icon?: React.ReactNode;
  onClick?: VoidFunction;
};

export const TileWrapper: FC<{ children: ReactNode }> = ({ children }) => (
  <Box position="relative">
    <AspectRatio ratio={1}>{children}</AspectRatio>
  </Box>
);

export const TileContent: FC<Props> = ({ children, icon, onClick }) => (
  <Box
    as="button"
    flexDirection="column"
    bg="white"
    height={80}
    p={6}
    textAlign="center"
    fontWeight="bold"
    lineHeight={1.2}
    transition="all 150ms ease-in-out"
    borderRadius={10}
    _hover={{
      transform: "translateY(-3px)",
    }}
    onClick={onClick}
  >
    {icon && (
      <Flex
        as="span"
        flex="1 1 auto"
        alignItems="center"
        justifyContent="center"
        mb={1}
      >
        {icon}
      </Flex>
    )}

    <Box as="span" position="absolute" top={5} right={5}>
      <Info size="20px" color="#3182ce" />
    </Box>

    {children}
  </Box>
);

const Tile: FC<Props> = props => (
  <TileWrapper>
    <TileContent {...props} />
  </TileWrapper>
);

export default Tile;
